import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { useLocation, useNavigate } from "react-router-dom";
import ApiBasketTemp from "../../../core/api/api.basketTemp";
import { NewBasketModal } from "./NewBasketModal";
import { InputGroup, Button, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import { tools } from "../../../core/utils/tools";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import ApiAmusementService from "../../../core/api/api.amusementService";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";

const Basket = () => {
  const [listData, setListData] = useState({});
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [amusementServiceList, setAmusementServiceList] = useState([]);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
        // دریافت لیست سبد های خرید کاربران
        const data = await ApiBasketTemp.getAllBasketTemp({
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          //typeGlobalSearch: "{typeGetAll: 'getNewBasket'}",
          globalSearch: searchParams.get("globalSearch"),
          createTimeOf: searchParams.get("createTimeOf"),
          createTimeTo: searchParams.get("createTimeTo"),
          useTimeOf: searchParams.get("useTimeOf"),
          useTimeTo: searchParams.get("useTimeTo"),
          orderServiceName: _.toString(searchParams.get("orderServiceName")),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const apiData = await ApiAmusementService.getAllServices();

        if (!_.isEmpty(apiData)) {
          setAmusementServiceList(apiData);
        } else {
          setAmusementServiceList([]);
        }
        const formInputs = [
          { name: "createTimeOf", type: "datePicker" },
          { name: "createTimeTo", type: "datePicker" },
          { name: "useTimeOf", type: "datePicker" },
          { name: "useTimeTo", type: "datePicker" },
          { name: "orderServiceName", type: "multiSelect", isMulti: true, data: apiData },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    if (data.createTimeOf !== null && typeof data.createTimeOf === "object") {
      data.createTimeOf = tools.DateFormat(data.createTimeOf);
    }
    if (data.createTimeTo !== null && typeof data.createTimeTo === "object") {
      data.createTimeTo = tools.DateFormat(data.createTimeTo);
    }
    if (data.useTimeOf !== null && typeof data.useTimeOf === "object") {
      data.useTimeOf = tools.DateFormat(data.useTimeOf);
    }
    if (data.useTimeTo !== null && typeof data.useTimeTo === "object") {
      data.useTimeTo = tools.DateFormat(data.useTimeTo);
    }
    if (data.orderServiceName?.length > 0) data.orderServiceName = data.orderServiceName?.map((item) => item.value);
    const apiData = await ApiBasketTemp.getAllBasketTemp({
      createTimeOf: data.createTimeOf,
      createTimeTo: data.createTimeTo,
      useTimeOf: data.useTimeOf,
      useTimeTo: data.useTimeTo,
      orderServiceName: _.toString(data.orderServiceName),
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
      typeGlobalSearch: "{typeGetAll: 'getNewBasket'}",
    });

    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    const queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    // // اضافه کردن query string به URL و انتقال به آن URL
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    navigate(`/basket?${queryString}`);
  };
  function handleChangeMultiOrderServiceName(value) {
    setValue("orderServiceName", value);
  }
  return (
    <div>
      {!_.isEmpty(location.state) && location.state?.newBasket ? <NewBasketModal /> : <></>}
      <div className="card card-custom">
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">مدیریت سبد های خرید</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست سبد های خرید</span>
          </h3>
          <div className="card-toolbar">
            {/* <Link
              className="btn btn-primary"
              key={0}
              to={{
                pathname: "/basket/0",
                state: { newBasket: true },
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد سبد
            </Link> */}
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          {/* search box */}
          <div className="">
            <FormProvider {...methods}>
              <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
                <div className="border-top pt-3">
                  {/* search box */}
                  <Accordion>
                    <Card>
                      <Accordion.Header as={Card.Header} variant="link">
                        <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                      </Accordion.Header>
                      <Accordion.Body>
                        <Card.Body>
                          <Row>
                            <Col xs="12" sm="6" xl="3" className="tb-responsive px-2  mt-5">
                              <Controller
                                name="createTimeOf"
                                control={control}
                                render={({ field: { onChange, value } }) => {
                                  return (
                                    <ShamsiDatePicker
                                      value={value}
                                      onChange={(date) => {
                                        var createTimeTo = getValues("createTimeTo");
                                        onChange(date);
                                        if (
                                          !createTimeTo ||
                                          (date?.toDate && date?.toDate()?.getTime() > new Date(createTimeTo).getTime())
                                        ) {
                                          // Set the value of createTimeTo to the same as createTimeTo
                                          setValue("createTimeTo", date);
                                        }
                                      }}
                                      placeholder="زمان ایجاد از"
                                    />
                                  );
                                }}
                              />
                            </Col>
                            <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2 mt-5">
                              <Controller
                                name="createTimeTo"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <ShamsiDatePicker value={value} onChange={onChange} placeholder="زمان ایجاد تا" />
                                )}
                              />
                            </Col>

                            <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                              <Controller
                                name="useTimeOf"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <ShamsiDatePicker
                                    className="mt-5"
                                    value={value}
                                    //onChange={onChange}
                                    onChange={(date) => {
                                      var useTimeTo = getValues("useTimeTo");
                                      onChange(date);
                                      if (!useTimeTo || (date?.toDate && date?.toDate()?.getTime() > new Date(useTimeTo).getTime())) {
                                        // Set the value of useTimeTo to the same as useTimeOf
                                        setValue("useTimeTo", date);
                                      }
                                    }}
                                    placeholder="زمان انجام تفریح از"
                                  />
                                )}
                              />
                            </Col>
                            <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2">
                              <Controller
                                name="useTimeTo"
                                control={control}
                                render={({ field: { onChange, value } }) => (
                                  <ShamsiDatePicker
                                    className="mt-5"
                                    value={value}
                                    onChange={onChange}
                                    placeholder="زمان انجام تفریح تا"
                                  />
                                )}
                              />
                            </Col>

                            <Col xs="12" sm="6" xl="3" className="tb-reponsive px-2 mt-5 ">
                              <Controller
                                name="orderServiceName"
                                control={control}
                                rules={{}}
                                render={({ field }) => (
                                  <SelectComponent
                                    className="mt-0"
                                    placeholder="نام سرویس"
                                    options={amusementServiceList?.map((item) => ({
                                      value: item.id,
                                      label: item.id + "-" + item.name,
                                    }))}
                                    field={field}
                                    onChange={handleChangeMultiOrderServiceName}
                                    isMulti
                                  />
                                )}
                              />
                            </Col>

                          </Row>
                          <Row className="pt-3">
                            <Col xs="auto" className="tb-reponsive px-2 px-3 mt-3">
                              <Button variant="success" type="submit" disabled={isSubmitting}>
                                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                                <SearchIcon />
                                جستجو
                              </Button>
                            </Col>
                            <Col xs="auto" className="tb-reponsive px-2 mt-3">
                              <Button
                                variant="light-danger"
                                type="submit"
                                disabled={isSubmitting}
                                onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                              >
                                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                                <i className="fas fa-refresh text-small"></i>
                                حذف جستجو{" "}
                              </Button>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Accordion.Body>
                    </Card>
                  </Accordion>
                  <InputGroup className="my-3">
                    <Controller
                      name="globalSearch"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <GlobalFormControl
                          type="text"
                          aria-describedby="basic-addon1"
                          placeholder="جستجو ..."
                          name="globalSearch"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />

                    <Button variant="secondary" type="submit" disabled={isSubmitting}>
                      <SearchIcon />
                    </Button>
                  </InputGroup>
                </div>
                {/* table */}
                <Col xs="12" className="tb-reponsive px-0">
                  <DataGrid data={listData} />
                </Col>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Basket;
